/**
 * Document title helper — every page uses `Page Name | Habits365Greek`.
 */
export const DOCUMENT_TITLE_BRAND = "Habits365Greek";

export function formatDocumentTitle(page?: string | null): string {
  const trimmed = page?.trim();
  if (!trimmed) return DOCUMENT_TITLE_BRAND;
  return `${trimmed} | ${DOCUMENT_TITLE_BRAND}`;
}
